import { Input, Output, Component, EventEmitter } from '@angular/core';
import { SpaContext } from '../../Classes/spacontext';
import { ApiResponse } from '../../Classes/visibaHttp.class';
import { AuthServiceV2 } from '../../Services/api/v2/auth.service';
import { VisibaPopup } from 'Public_old/src/app/Common/Classes/visibaPopup';
import { parse, format, isValidNumber } from 'libphonenumber-js';
import { TranslateService } from 'Public_old/src/app/Common/Services/translate.service';
import type { SignInOnFinishedEvent } from './SignInOnFinishedEvent';
import { SmsStartAuthModel } from '@public/src/api/generated/models';
import { SmsAuthService } from '../../Services/api/v2/smsAuth.service';

@Component({
	standalone: false,
	template: `
		<h2 [class.nhsFont]="countryCode === 'GB'">
			{{ 'LicenceHolder.Component.SmsLoginComponent.Title.MethodSmsLogin' | translate }}
		</h2>
		<form novalidate (ngSubmit)="submitNumber()" #numberform="ngForm" *ngIf="showNumberForm">
			<div class="row codeField" [class.nhsStyling]="countryCode === 'GB'">
				<visiba-tel required [(ngModel)]="model.Number" [readonly]="isOutsider" name="number" [country]="countryCode"></visiba-tel>
			</div>
			<div class="row err" *ngIf="errorMessageNumber != null">{{ errorMessageNumber }}</div>
			<div class="row">
				<button
					class="btn"
					[class.small]="countryCode === 'GB'"
					[class.large]="countryCode !== 'GB'"
					[class.nhsButton]="countryCode === 'GB'"
				>
					{{ 'LicenceHolder.Component.SmsLoginComponent.Button.SubmitNumber' | translate }}
				</button>
			</div>
		</form>
		<form novalidate (ngSubmit)="onSubmit()" #codeform="ngForm" *ngIf="showCodeForm">
			<div class="row codeSent">
				{{ 'LicenceHolder.Component.SmsLoginComponent.Phrase.CodeSent' | translate: { number: number } : 1 }}
			</div>
			<div class="row codeField">
				<visiba-input
					required
					maxlength="6"
					type="text"
					[(ngModel)]="model.Code"
					name="code"
					placeholder="LicenceHolder.Component.SmsLoginComponent.Placeholder.YourCode"
				></visiba-input>
			</div>
			<div class="row err" *ngIf="errorMessage != null">{{ errorMessage }}</div>
			<div class="row">
				<button
					class="btn large"
					[class.small]="countryCode === 'GB'"
					[class.large]="countryCode !== 'GB'"
					[class.nhsButton]="countryCode === 'GB'"
				>
					{{ 'Common.Button.SignIn' | translate }}
				</button>
			</div>
			<div class="row codeAgain">
				<button type="text" class="btn ghost" (click)="resendCode()">
					{{ 'LicenceHolder.Component.SmsLoginComponent.Button.GetSmsCode' | translate }}
				</button>
			</div>
		</form>
	`,
	selector: 'sms-login',
})
export class SmsLoginComponent {
	@Output() onFinished = new EventEmitter<SignInOnFinishedEvent>();
	@Input() countryCode: string;
	@Input('ticket') callTicket: Guid | null = null;
	@Input('isOutsider') isOutsider = false;
	attempt: SmsStartAuthModel;
	smsTries = 0;
	showNumberForm = false;
	showCodeForm = false;
	model: any = { Number: '' };
	errorMessageNumber: string = null;
	errorMessage: string = null;
	public gettingCode = false;
	number: string | null = null;

	constructor(
		private spaContext: SpaContext,
		private smsAuthService: SmsAuthService,
		private authService: AuthServiceV2,
		private translateService: TranslateService,
	) {}

	ngOnInit() {
		if (this.callTicket !== null && !this.isOutsider) {
			this.getCode();
		} else if (this.isOutsider && this.callTicket !== null) {
			this.authService.getPreRegisteredNumber(this.callTicket, this.spaContext.unitConfig.Unit.UnitId).subscribe((response) => {
				this.model.Number = response.data;
				this.showNumberForm = true;
			});
		} else {
			this.showNumberForm = true;
		}
	}

	submitNumber() {
		this.getCode();
	}

	onSubmit() {
		if (this.isOutsider) {
			this.authService.confirmSmsCode(this.spaContext.unitConfig.Unit.UnitId, this.attempt.AttemptId, this.model.Code).subscribe(
				() => {
					this.onFinished.emit({ code: 'Signed' });
				},
				(err: ApiResponse<any>) => {
					if (err.errorCode === 'MaxAuthAttemptExeeded') {
						new VisibaPopup(this.translateService.get('LicenceHolder.Component.SmsLoginComponent.Title.MaxAuthAttemptExeeded'), null)
							.inform(this.translateService.get('Common.Button.OK'))
							.attatch()
							.observer()
							.subscribe(
								() => {
									this.showNumberForm = true;
									this.showCodeForm = false;
									this.attempt = null;
									this.errorMessage = null;
									this.model.Code = null;
								},
								() => {},
							);
					} else if (err.errorMessage !== null) {
						this.errorMessage = err.errorMessage;
					} else {
						this.errorMessage = this.translateService.get('LicenceHolder.Component.SmsLoginComponent.Phrase.InvalidSmsCode');
					}
				},
			);
		} else {
			this.smsAuthService.confirmCode(this.attempt.AttemptId, this.model.Code).subscribe(
				(response) => {
					if (response.data.RegistrationTicket !== null) {
						this.onFinished.emit({ code: 'Register', data: { ticket: response.data.RegistrationTicket } });
					} else {
						this.onFinished.emit({ code: 'Signed' });
					}
				},
				(err: ApiResponse<any>) => {
					if (err.errorCode === 'MaxAuthAttemptExeeded') {
						new VisibaPopup(this.translateService.get('LicenceHolder.Component.SmsLoginComponent.Title.MaxAuthAttemptExeeded'), null)
							.inform(this.translateService.get('Common.Button.OK'))
							.attatch()
							.observer()
							.subscribe(
								() => {
									this.showNumberForm = true;
									this.showNumberForm = true;
									this.showCodeForm = false;
									this.attempt = null;
									this.errorMessage = null;
									this.model.Code = null;
								},
								() => {},
							);
					} else if (err.errorMessage !== null) {
						this.errorMessage = err.errorMessage;
					} else {
						this.errorMessage = this.translateService.get('LicenceHolder.Component.SmsLoginComponent.Phrase.InvalidSmsCode');
					}
				},
			);
		}

		return false;
	}

	resendCode() {
		if (this.smsTries > 2) return false;

		this.smsTries++;

		this.smsAuthService.resendCode(this.attempt.AttemptId).subscribe(
			() => {},
			() => {
				this.errorMessageNumber = this.translateService.get('LicenceHolder.Component.SmsLoginComponent.Phrase.UnableToGetCode');
			},
		);
	}

	getCode() {
		if (this.model.Number !== null && this.model.Number.length < 6) this.model.Number = null;

		let phoneNumber = null;
		if (this.model.Number !== null) {
			try {
				const parsedNum = parse(this.model.Number, this.countryCode as any);
				if (isValidNumber(parsedNum)) {
					phoneNumber = format(parsedNum, 'INTERNATIONAL');
				}
			} catch (numberParseException) {
				phoneNumber = null;
			}
		}

		if (this.callTicket === null && (phoneNumber === null || this.model.Number === null || this.model.Number === '')) {
			this.errorMessageNumber = this.translateService.get('LicenceHolder.Component.SmsLoginComponent.Phrase.InvalidNumber');

			return false;
		}

		this.number = this.model.Number;
		this.smsTries++;
		this.gettingCode = true;

		if (this.isOutsider) {
			this.authService.sendSMSCodeWithCallticket(this.spaContext.unitConfig.Unit.UnitId, this.countryCode, this.callTicket).subscribe(
				(response) => {
					this.showNumberForm = false;
					this.showCodeForm = true;
					this.attempt = response.data;
					this.gettingCode = false;
				},
				() => {
					this.errorMessageNumber = this.translateService.get('LicenceHolder.Component.SmsLoginComponent.Phrase.UnableToGetCode');
					this.gettingCode = false;
				},
			);
		} else {
			this.smsAuthService
				.beginSmsAuth(this.spaContext.unitConfig.LicenceHolder.Id, this.countryCode, this.model.Number, this.callTicket)
				.subscribe(
					(response) => {
						this.showNumberForm = false;
						this.showCodeForm = true;
						this.attempt = response.data;
						this.gettingCode = false;
					},
					() => {
						this.errorMessageNumber = this.translateService.get('LicenceHolder.Component.SmsLoginComponent.Phrase.UnableToGetCode');
						this.gettingCode = false;
					},
				);
		}
	}
}
